import React from "react";
import { useNavigate } from "react-router-dom";
import "./DemographicsData.css";
import "./review.css";

const DemographicsData = () => {
    const navigate = useNavigate();
    // Hardcoded data for now, as requested to match design "exactly"
    // In a real app, this would likely come from props or context/store
    const timelineData = [
        { id: 1, label: "Client", value: "James" },
        { id: 2, label: "Gender", value: "Male" },
        { id: 3, label: "Age", value: "6-12 months" },
        { id: 4, label: "Appointment", value: "Initial" },
    ];

    return (
        <>
            
            <main className="demographics-page">

                <div className="dd-header">
                    <button className="dd-back-btn" onClick={() => navigate(-1)} aria-label="Go to previous page">
                        ← Previous page
                    </button>
                    <div className="dd-title-container">
                        <h2 className="dd-title">Previous Demographics Data</h2>
                    </div>
                    {/* Empty div to balance the header flex layout if needed, or just let space-between handle it */}
                    <div style={{ width: '100px' }}></div>
                </div>

                <div className="dd-timeline">
                    {timelineData.map((item, index) => (
                        <div key={item.id} className="dd-timeline-item">
                            <div className="dd-timeline-marker">
                                <div className="dd-circle">{item.id}</div>
                                {index < timelineData.length - 1 && <div className="dd-line"></div>}
                            </div>
                            <div className="dd-content">
                                <span className="dd-label">{item.label}-</span>
                                <span className="dd-value">{item.value}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </main>
           
        </>


    );
};

export default DemographicsData;
